export default __webpack_public_path__ + "static/media/hollow-top.b3f6d274.svg";